var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-stack",style:(("--v-stack-gap: var(--s" + _vm.gap + "); --v-stack-padY: var(--s" + _vm.padY + ");  --v-stack-padX: var(--s" + _vm.padX + ");"))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }